// extracted by mini-css-extract-plugin
module.exports = {"default":"_type_default__3LVJL","dense":"_type_dense__1lbYs","right":"_type_right__2Z931"};